import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: ${({ turnos }) => turnos ? `750px` : `190px`};
  background-color: var(--color-white);
  border-radius: 8px;
  @media (max-width: 500px) {
    width: 100%;
  }
  button {
    width: 170px;
    height: 40px;
    /* border: 2px solid var(--color-latex30); */
    /* color: var(--color-latex30); */
    border-radius: 8px;
    /* background: transparent; */
    font-size: 18px;
    margin: 15px;
  }
  .cruz {
    font-size: 18px;
  }
  .boxPresentesAusentes{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
`;

export const Top = styled.div`
  height: 54px;
  background: var(--color-latex30);
  color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  span {
    font-weight: bold;
    font-size: 18px;
  }
`;

export const Body = styled.div`
  width: 332px;
  height: ${({ turnos }) => turnos ? `600px` : `50px`};
  padding: ${({ turnos }) => turnos ? `` : `10px`};
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: scroll;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
`;

export const LineaSeparadora = styled.hr`
  display: flex;
  height: 2px;
  width: 100%;
  /* background: var(--color-white); */
  background: linear-gradient(180deg, #c4c4c4 0%, rgba(196, 196, 196, 0) 100%);
`;

export const TurnosContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  gap: 10px;
  width: 100%;
  .tipoConsultaEstado {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .iconEstado {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  p {
    text-align: left;
  }
`;
